var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCallout',{staticClass:"folder-upsell-callout py-3 mx-4",attrs:{"type":"info","icon":"folder"}},[_vm._v("\n\tYou lost your folders!\n\t"),_c('RouterLink',{attrs:{"to":_vm.upgradeLink}},[_vm._v("Upgrade now")]),_vm._v(" to restore them.\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }